export default props => props.condition ? props.children : null